import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';
import { SearchStatus, TravelTypes } from '../../constants';

const initialState = {
  agentTips: {},
  error: {},
};

const intelligenceSlice = createSlice({
  name: 'intelligence',
  initialState,
  reducers: {
    resetAgentTips: (state) => ({
      ...state,
      agentTips: {},
    }),

    getAgentTipsRequest: (state, { payload }) => ({
      ...state,
      agentTips: {
        ...state.agentTips,
        [payload.cruiseItineraryId]: {
          ...state.agentTips[payload.cruiseItineraryId],
          status: SearchStatus.SEARCHING,
        },
      },
    }),

    getAgentTipsSuccess: (state, { payload }) => ({
      ...state,
      agentTips: {
        ...state.agentTips,
        [`${payload.cruiseItineraryId}-${payload.flightOriginGeoIndex}`]: {
          tips: [...payload.tips],
          status: payload.status,
        },
      },
    }),

    getAgentTipsDebuggingInfo: (state, { payload }) => ({
      ...state,
      agentTips: {
        ...state.agentTips,
        [`${payload.cruiseItineraryId}-${payload.flightOriginGeoIndex}`]: {
          ...state.agentTips[`${payload.cruiseItineraryId}-${payload.flightOriginGeoIndex}`],
          debuggingInfo: payload.debuggingInfo,
        },
      },
    }),

    getAgentTipsFail: (state, { payload }) => ({
      ...state,
      agentTips: {
        ...state.agentTips,
        [payload.cruiseItineraryId]: {
          ...state.agentTips[payload.cruiseItineraryId],
          tips: [],
          error: payload.error,
          status: SearchStatus.DONE,
        },
      },
    }),

    updateFlightInAgentTipRequest: (state, {
      payload: {
        cruiseItineraryId,
        agentTipId,
        flightOriginGeoIndex,
      },
    }) => {
      const updatedTips = [...state.agentTips[`${cruiseItineraryId}-${flightOriginGeoIndex}`].tips];

      updatedTips[agentTipId] = {
        ...updatedTips[agentTipId],
        flightStatus: SearchStatus.SEARCHING,
      };
      return {
        ...state,
        agentTips: {
          ...state.agentTips,
          [`${cruiseItineraryId}-${flightOriginGeoIndex}`]: {
            ...state.agentTips[`${cruiseItineraryId}-${flightOriginGeoIndex}`],
            tips: [...updatedTips],
          },
        },
      };
    },

    updateFlightInAgentTipResponse: (state, {
      payload: {
        cruiseItineraryId,
        agentTipId,
        flightOriginGeoIndex,
        response,
      },
    }) => {
      const updatedTips = [...state.agentTips[`${cruiseItineraryId}-${flightOriginGeoIndex}`].tips];
      updatedTips[agentTipId] = {
        ...updatedTips[agentTipId],
        flightStatus: SearchStatus.DONE,
      };

      if (response) {
        updatedTips[agentTipId] = {
          ...updatedTips[agentTipId],
          itineraries: [...updatedTips[agentTipId].itineraries],
        };
        updatedTips[agentTipId].itineraries[updatedTips[agentTipId].itineraries.length] = {
          ...response,
        };
      }

      return {
        ...state,
        agentTips: {
          ...state.agentTips,
          [`${cruiseItineraryId}-${flightOriginGeoIndex}`]: {
            ...state.agentTips[`${cruiseItineraryId}-${flightOriginGeoIndex}`],
            tips: [...updatedTips],
          },
        },
      };
    },

    updateHotelInAgentTipRequest: (state, {
      payload: {
        cruiseItineraryId,
        agentTipId,
        flightOriginGeoIndex,
      },
    }) => {
      const updatedTips = [...state.agentTips[`${cruiseItineraryId}-${flightOriginGeoIndex}`].tips];
      updatedTips[agentTipId] = {
        ...updatedTips[agentTipId],
        hotelStatus: SearchStatus.SEARCHING,
      };
      return {
        ...state,
        agentTips: {
          ...state.agentTips,
          [`${cruiseItineraryId}-${flightOriginGeoIndex}`]: {
            ...state.agentTips[`${cruiseItineraryId}-${flightOriginGeoIndex}`],
            tips: [...updatedTips],
          },
        },
      };
    },

    updateHotelInAgentTipResponse: (state, {
      payload: {
        cruiseItineraryId,
        agentTipId,
        flightOriginGeoIndex,
        response,
      },
    }) => {
      const updatedTips = [...state.agentTips[`${cruiseItineraryId}-${flightOriginGeoIndex}`].tips];
      updatedTips[agentTipId] = {
        ...updatedTips[agentTipId],
        hotelStatus: SearchStatus.DONE,
      };

      if (response) {
        const hotelItineraryIndex = _.findIndex(updatedTips[agentTipId].itineraries || [],
          (i) => i.mode === TravelTypes.hotel);
        updatedTips[agentTipId] = {
          ...updatedTips[agentTipId],
          itineraries: [...updatedTips[agentTipId].itineraries],
        };
        updatedTips[agentTipId].itineraries[hotelItineraryIndex] = {
          ...response,
        };
      }

      return {
        ...state,
        agentTips: {
          ...state.agentTips,
          [`${cruiseItineraryId}-${flightOriginGeoIndex}`]: {
            ...state.agentTips[`${cruiseItineraryId}-${flightOriginGeoIndex}`],
            tips: [...updatedTips],
          },
        },
      };
    },
  },
});

export const {
  resetAgentTips,
  getAgentTipsRequest,
  getAgentTipsSuccess,
  getAgentTipsDebuggingInfo,
  getAgentTipsFail,
  updateHotelInAgentTipRequest,
  updateHotelInAgentTipResponse,
  updateFlightInAgentTipRequest,
  updateFlightInAgentTipResponse,
} = intelligenceSlice.actions;
export default intelligenceSlice.reducer;
